var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcoYoutube = function SvgIcoYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.016
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "ico-youtube",
    d: "M2.057 13.608a2.333 2.333 0 0 1-1.536-1.492C-.143 10.288-.34 2.641.94 1.135A2.48 2.48 0 0 1 2.611.247c3.449-.372 14.11-.318 15.338.125a2.4 2.4 0 0 1 1.508 1.45c.727 1.889.753 8.764-.1 10.585a2.327 2.327 0 0 1-1.081 1.091c-1.278.676-14.526.668-16.219.11Zm5.479-3.584c2.074-1.076 4.13-2.141 6.211-3.222L7.536 3.561Z",
    fill: "#35272a",
    fillRule: "evenodd"
  })));
};

export default SvgIcoYoutube;